import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput } from "../../components/neu/Neu";
import { SupplierPicker } from "./SupplierPicker";
import { orderFromRequisition } from "../../api/purchases";
import { fmtMoney } from "../../lib/format";

const today = () => new Date().toISOString().slice(0, 10);

// طلب شراء معتمد ← أمر شراء لمورّد يُختار بالكتابة (الفصل بين الطالب والمشتري).
export const RequisitionToOrder = ({ requisition, onDone }) => {
  const { t } = useTranslation();
  const [supplierId, setSupplierId] = useState("");
  const [date, setDate] = useState(today());
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const order = await orderFromRequisition({
        requisition_id: requisition.id,
        supplier_id: supplierId,
        date,
      });
      toast.success(`${t("purchases.orderFromRequisitionDone")} — ${fmtMoney(order.totals.payable)} ${order.money.currency}`);
      onDone?.();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code || t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="grid gap-3 p-4" data-testid="requisition-to-order">
      <p className="label-xs">{t("purchases.convertToOrder")}</p>
      <div className="grid gap-3 sm:grid-cols-[2fr_1fr_auto]">
        <SupplierPicker testid="convert-supplier" value={supplierId} onChange={setSupplierId} />
        <NeuInput data-testid="convert-date" type="date" value={date}
                  onChange={(e) => setDate(e.target.value)} />
        <NeuButton variant="primary" className="px-4 py-2 text-xs" data-testid="convert-run"
                   disabled={busy || !supplierId} onClick={run}>
          {t("purchases.createOrderNow")}
        </NeuButton>
      </div>
    </NeuCard>
  );
};
